import {Action} from '@ngrx/store';

export const ADD_SMS = '[Sms] Add';
export const ADD_SMS_SUCCESS = '[Sms] Add Success';
export const ADD_SMS_ERROR = '[Sms] Add Error';


export class AddSms implements Action {
  readonly type = ADD_SMS;

  constructor(public payload: any) {
  }
}

export class AddSmsSuccess implements Action {
  readonly type = ADD_SMS_SUCCESS;

  constructor(public payload: any) {
  }
}

export class AddSmsError implements Action {
  readonly type = ADD_SMS_ERROR;

  constructor(public payload: any) {
  }
}


export type SmsBlastAction =
  AddSms
  | AddSmsSuccess
  | AddSmsError;



// WEBPACK FOOTER //
// /Users/Chetan/Downloads/angular5_admin-master/src/app/store/actions/sms-blast.action.ts